import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import sys from '@/sys';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsoleComponent',
  emits: ['submit','esc'],
  setup(__props, { expose: __expose, emit: __emit }) {

const textbox = ref<InstanceType<typeof HTMLInputElement> | null>(null)

const emit = __emit

function esc(args: KeyboardEvent) {

    if (args.code == 'Escape') {

        consoleContentClear()
        args.preventDefault()
        args.stopPropagation();
        emit('esc')
    }

}

function submit() {

    const v = consoleContent();

    if (v != '') {

        emit('submit', v)

        consoleContentClear();
    }
}

function consoleContent(): string {

    if (textbox.value != null) {

        const t = textbox.value;

        return t.value.trim();
    }
    else sys.warn("Can't find console element at page")

    return ''
}

function consoleContentClear() {

    if (textbox.value != null) {

        const t = textbox.value;
        t.value = ''
    }
    else sys.warn("Can't find console element at page")
}

__expose({ consoleContent, consoleClear, focus })

function focus() {

        if (textbox.value != null) {

                const t = textbox.value;

                t.focus()
        }

}

function consoleClear() {

        return consoleContentClear()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "text",
    onKeydown: [
      _withKeys(submit, ["enter"]),
      esc
    ],
    ref_key: "textbox",
    ref: textbox
  }, null, 544))
}
}

})